import PerfectScrollbar from "perfect-scrollbar";

const psContainers = document.querySelectorAll('[data-perfect-scrollbar]');
psContainers.forEach(container => {

    let options = container.getAttribute('data-perfect-scrollbar')
        ? JSON.parse(container.getAttribute('data-perfect-scrollbar'))
        : {
            minScrollbarLength: 32
        }

    new PerfectScrollbar(container, options)
});